import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

export class ActivateUserTrialCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
  ) {}

  run(user_id, init_date, logged_user): Promise<{ [key: string]: string; }> {
    console.log("ActivateUserTrialCommand")
    let args = {user_id:user_id, start_date:init_date, who_trained:logged_user}
    return this.dispatcher.dispatch('activate.user.trial', args) 
  }
}